import { cycleStandardNames } from "./inspectionCycleValidation";
import { Fragment, useEffect, useMemo } from "react";

import {
  Progress,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
  Form,
  FormFeedback,
} from "../../components/Common/AppOverlay";

import { useNavigate } from "react-router-dom";
import React, { useRef, useState } from "react";
import ActionMenu from "../../components/Common/ActionMenu";
import Select from "react-select";
import {
  getEngagementList,
  getLoggedInUser,
  getMeetingTasks,
  searchInspectionCycles,
} from "../../helpers/backend_helper";
import * as url from "../../helpers/url_helper";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import classnames from "classnames";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import InspectionCycleDetailsForm from "./InspectionCycleDetailsForm";
import InspectionCycleHistory from "./InspectionCycleHistory";
import CustomDataGrid from "../../components/Common/CustomDataGrid";
import SummaryCards from "../../components/Common/SummaryCards";
import UnsavedChangesDialog from "../../components/Common/UnsavedChangesDialog";
import "./InspectionCycleList.scss";

const InspectionCycleActionMenu = ({
  inspectionCycleId,
  onAction,
  canManage,
}) => (
  <ActionMenu
    label="inspection cycle"
    actions={[
      ...(canManage
        ? [
            {
              label: "Edit details",
              icon: <i className="bx bx-pencil" aria-hidden="true" />,
              onSelect: () => onAction("edit", inspectionCycleId),
            },
          ]
        : []),
      {
        label: "Preview",
        icon: <i className="bx bx-show" aria-hidden="true" />,
        onSelect: () => onAction("preview", inspectionCycleId),
      },
      {
        label: "View activities",
        icon: <i className="bx bx-history" aria-hidden="true" />,
        onSelect: () => onAction("activities", inspectionCycleId),
      },
    ]}
  />
);


const InspectionCycleList = (props) => {
  const navigate = useNavigate();

  const [activeTab, setactiveTab] = useState(1);
  const [showTab, setShowTab] = useState(1);

  const [inspectionCycles, setInspectionCycles] = useState([]);
  const [engagementCounts, setEngagementCounts] = useState({});
  const [archivedCount, setArchivedCount] = useState(0);
  const gridRequest = useRef(0);
  useEffect(
    () => () => {
      gridRequest.current += 1;
    },
    []
  );
  const [gridLoading, setGridLoading] = useState(true);
  const [gridError, setGridError] = useState("");
  const [detailId, setDetailId] = useState(0);
  const [inspectionCycleDetailsOpen, setInspectionCycleDetailsOpen] =
    useState(false);
  const [inspectionCycleOpen, setInspectionCycleOpen] = useState(false);
  const [inspectionCycleFormDirty, setInspectionCycleFormDirty] =
    useState(false);
  const [
    inspectionCycleDiscardConfirmOpen,
    setInspectionCycleDiscardConfirmOpen,
  ] = useState(false);
  const [filters, setFilters] = useState({
    status: "all",
    standard: "all",
    title: "",
  });
  const [quickFilter, setQuickFilter] = useState("all");
  const [isEngagementMember, setIsEngagementMember] = useState(true);
  const [leavingForCreate, setLeavingForCreate] = useState(false);

  useEffect(() => {
    console.log("inside useEffect");
    console.log(props.dataId);

    loadActiveInspectionCycles();
    getLoggedInUser().then((account) => {
      const roleName =
        account?.role?.name ||
        account?.roleName ||
        account?.userRole?.name ||
        account?.designation ||
        "";
      setIsEngagementMember(
        Number(account?.roleId) === 4 || /engagement\s+member/i.test(roleName)
      );
    });
  }, []);

  const loadData = () => {
    if (activeTab == 1) loadActiveInspectionCycles();
    else if (activeTab === 3) loadInspectionCycles(3);
    else loadPastInspectionCycles();
  };

  const toggleInspectionCycleDetails = () => {
    setInspectionCycleDetailsOpen(!inspectionCycleDetailsOpen);
  };

  const closeInspectionCycle = () => {
    setInspectionCycleOpen(false);
    setInspectionCycleFormDirty(false);
  };

  const toggleInspectionCycle = () => {
    if (inspectionCycleOpen) {
      if (inspectionCycleFormDirty) {
        setInspectionCycleDiscardConfirmOpen(true);
        return;
      }
      closeInspectionCycle();
      return;
    }
    setInspectionCycleFormDirty(false);
    setInspectionCycleOpen(true);
  };

  const discardInspectionCycleDraft = () => {
    setInspectionCycleDiscardConfirmOpen(false);
    closeInspectionCycle();
  };

  const onInspectionCycleClose = (data) => {
    closeInspectionCycle();
    loadActiveInspectionCycles();
  };

  const loadInspectionCycles = async (projectStatusId) => {
    const requestId = ++gridRequest.current;
    setGridLoading(true);
    setGridError("");
    try {
      const [res, engagementResponse, archivedResponse] = await Promise.all([
        searchInspectionCycles({ projectTypeId: 0, projectStatusId }),
        getEngagementList().catch(() => null),
        searchInspectionCycles({ projectTypeId: 0, projectStatusId: 3 }),
      ]);
      if (requestId !== gridRequest.current) return;
      if (!res.status)
        throw new Error(res.message || "Unable to load inspection cycles.");
      setInspectionCycles((res.data || []).map((cycle) =>
        projectStatusId === 3 ? { ...cycle, reviewStatus: "Archived" } : cycle
      ));
      setArchivedCount(archivedResponse?.status ? (archivedResponse.data || []).length : null);
      if (engagementResponse?.status) {
        const counts = (engagementResponse.data || []).reduce(
          (result, engagement) => {
            const inspectionCycleId = Number(engagement.inspectionCycleId);
            if (inspectionCycleId)
              result[inspectionCycleId] = (result[inspectionCycleId] || 0) + 1;
            return result;
          },
          {}
        );
        setEngagementCounts(counts);
      }
      window.dispatchEvent(new Event("piers:readiness-changed"));
    } catch (error) {
      if (requestId === gridRequest.current)
        setGridError(error.message || "Unable to load inspection cycles.");
    } finally {
      if (requestId === gridRequest.current) setGridLoading(false);
    }
  };

  const loadActiveInspectionCycles = () => loadInspectionCycles(1);

  const loadPastInspectionCycles = () => loadInspectionCycles(2);

  const headerLink = (props) => {
    return (
      <div>
        <button
          onClick={() => navigate(`/inspections/${props.id}/preview`)}
          color="primary"
          className="btn btn-link btn-sm waves-effect waves-light book-open"
        >
          {props.projectNo}
        </button>
      </div>
    );
  };

  const newInspectionCycle = () => {
    if (leavingForCreate) return;
    setLeavingForCreate(true);
    window.setTimeout(() => navigate("/inspections/new"), 240);
  };

  const handleAction = (action, inspectionCycleId) => {
    setDetailId(inspectionCycleId);

    if (action === "activities") {
      setInspectionCycleDetailsOpen(true);
    } else if (action === "preview") {
      navigate(`/inspections/${inspectionCycleId}/preview`);
    } else {
      toggleInspectionCycle();
    }
  };

  const getStatusTone = (status) => {
    if (/complete|closed/i.test(status)) return "completed";
    if (/cancel/i.test(status)) return "canceled";
    if (/progress|active/i.test(status)) return "in-progress";
    return "not-started";
  };

  const getStatusCount = (tone) =>
    inspectionCycles.filter(
      (project) => getStatusTone(project.reviewStatus || project.projectStatus?.name || "") === tone
    ).length;
  const totalCycles = inspectionCycles.length;
  const notStartedCount = getStatusCount("not-started");
  const inProgressCount = getStatusCount("in-progress");
  const completedCount = getStatusCount("completed");

  const standardOptions = useMemo(
    () => [
      ...new Set(
        inspectionCycles
          .flatMap((project) => cycleStandardNames(project).split(", "))
          .filter(Boolean)
      ),
    ],
    [inspectionCycles]
  );

  const visibleInspectionCycles = useMemo(
    () =>
      inspectionCycles.filter((project) => {
        const tone = getStatusTone(project.reviewStatus || project.projectStatus?.name || "");
        if (filters.status !== "all" && tone !== filters.status) return false;
        if (
          filters.standard !== "all" &&
          !cycleStandardNames(project).split(", ").includes(filters.standard)
        )
          return false;
        if (
          filters.title &&
          ![project.projectNo, project.title, cycleStandardNames(project)].some((value) => String(value || "").toLowerCase().includes(filters.title.toLowerCase()))
        )
          return false;
        if (quickFilter === "recent" && !project.updatedOn) return false;
        if (
          !["all", "assigned", "recent"].includes(quickFilter) &&
          quickFilter !== tone
        )
          return false;
        return true;
      }),
    [inspectionCycles, filters, quickFilter]
  );

  const updateFilter = (name, value) =>
    setFilters((current) => ({ ...current, [name]: value }));

  const resetFilters = () => {
    setFilters({ status: "all", standard: "all", title: "" });
    setQuickFilter("all");
  };

  const inspectionCycleColumns = [
    {
      id: "projectNo",
      header: "Inspection No.",
      accessorKey: "projectNo",
      cell: ({ row }) => headerLink(row.original),
      size: 130,
      flex: 0.8,
    },
    {
      id: "title",
      header: "Title",
      accessorKey: "title",
      size: 290,
      flex: 1.7,
      cell: ({ row }) => (
        <button
          className="btn btn-link p-0 text-start"
          onClick={() => navigate(`/inspections/${row.original.id}/preview`)}
        >
          {row.original.title || row.original.projectTitle}
        </button>
      ),
    },
    {
      id: "standardType",
      header: "Standard Type",
      accessorFn: (row) => cycleStandardNames(row),
      size: 160,
      flex: 1,
    },
    {
      id: "engagements",
      header: "Engagements",
      accessorFn: (row) =>
        engagementCounts[Number(row.id ?? row.inspectionCycleId)] || 0,
      size: 135,
      flex: 0.85,
      cell: ({ getValue }) => <strong>{getValue()}</strong>,
    },
    {
      id: "status",
      header: "Status",
      accessorFn: (row) => row.reviewStatus || row.projectStatus?.name || "",
      size: 160,
      flex: 1.1,
      cell: ({ getValue }) => {
        const status = getValue() || "Not set";
        const tone = getStatusTone(status);

        return (
          <span
            className={`inspection-cycle-status-pill inspection-cycle-status-pill--${tone}`}
          >
            {status}
          </span>
        );
      },
    },
    {
      id: "progress",
      header: "Progress",
      accessorFn: (row) => row.reviewProgress ?? row.projectPercentage ?? 0,
      size: 145,
      flex: 1,
      cell: ({ getValue }) => {
        const progress = Math.min(Math.max(Number(getValue()) || 0, 0), 100);
        return (
          <div className="inspection-cycle-progress">
            <span>{progress}%</span>
            <span className="inspection-cycle-progress__track">
              <i style={{ width: `${progress}%` }} />
            </span>
          </div>
        );
      },
    },
    {
      id: "actions",
      header: "Actions",
      accessorFn: () => "",
      enableSorting: false,
      enableColumnFilter: false,
      enableExport: false,
      size: 155,
      minSize: 155,
      flex: 0,
      cell: ({ row }) => (
        <div className="d-flex align-items-center gap-2 h-100">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => handleAction("preview", row.original.id ?? row.original.inspectionCycleId)}
          >
            Preview
          </button>
        <InspectionCycleActionMenu
          inspectionCycleId={row.original.id ?? row.original.inspectionCycleId}
          onAction={handleAction}
          canManage={!isEngagementMember}
        />
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <div
        className={(classnames("page-content inspection-cycle-page", {
          "inspection-cycle-page--leaving": leavingForCreate,
        })) + " piers-page"}
      >
        <header className="inspection-cycle-page__header piers-page-header">
          <div>
            <h1 className="piers-page-title">Inspection Cycles</h1>
            <p>
              Create and manage inspection cycles, then continue to their
              engagements.
            </p>
          </div>
          <div className="inspection-cycle-create">
            <button
              type="button"
              className="inspection-cycle-refresh piers-refresh-button"
              onClick={loadData}
              title="Refresh inspection cycles"
            >
              <i className="bx bx-refresh" aria-hidden="true" /> Refresh
            </button>
            {!isEngagementMember && (
              <button
                type="button"
                data-onboarding-target="inspection"
                onClick={newInspectionCycle}
                disabled={leavingForCreate}
              >
                <i className="bx bx-plus" aria-hidden="true" /> New Inspection
                Cycle
              </button>
            )}
          </div>
        </header>
        <SummaryCards
          variant="action"
          items={[
            ["Total Cycles", totalCycles, "bx-clipboard", "blue", "all"],
            [
              "Not Started",
              notStartedCount,
              "bx-play",
              "orange",
              "not-started",
            ],
            [
              "In Progress",
              inProgressCount,
              "bx-time-five",
              "blue",
              "in-progress",
            ],
            [
              "Completed",
              completedCount,
              "bx-check-circle",
              "green",
              "completed",
            ],
            ["Archived", archivedCount ?? "—", "bx-archive", "blue", "archived"],
          ].map(([label, count, icon, tone, status]) => ({
            icon,
            tone,
            label,
            value: count,
            active: status === "archived"
              ? activeTab === 3
              : activeTab !== 3 && filters.status === status && quickFilter === "all",
            note:
              status === "archived" ? "Archived inspection cycles" : status === "all"
                ? "All inspection cycles"
                : `${
                    totalCycles ? Math.round((count / totalCycles) * 100) : 0
                  }% of total`,
            onClick: () => {
              if (status === "archived") {
                resetFilters();
                setShowTab(1);
                setactiveTab(3);
                loadInspectionCycles(3);
                return;
              }
              if (activeTab === 3) { setactiveTab(1); loadActiveInspectionCycles(); }
              setFilters({ status, standard: "all" });
              setQuickFilter("all");
            },
          }))}
          ariaLabel="Inspection cycle summary"
        />
        <nav
          className="inspection-cycle-tabs"
          aria-label="Inspection cycle views"
        >
          <button
            type="button"
            className={classnames({ active: activeTab === 1 })}
            onClick={() => {
              setShowTab(1);
              setactiveTab(1);
              loadActiveInspectionCycles();
            }}
          >
            All Active
          </button>
          <button
            type="button"
            className={classnames({ active: activeTab === 2 })}
            onClick={() => {
              setShowTab(1);
              setactiveTab(2);
              loadPastInspectionCycles();
            }}
          >
            Past Inspection Cycles
          </button>
        </nav>
        <div className="inspection-cycle-results-heading">
          <div aria-live="polite" role="status">
            <h3>{activeTab === 3 ? "Archived" : activeTab === 2 ? "Past" : ({ "not-started": "Not Started", "in-progress": "In Progress", completed: "Completed" }[filters.status] || "Total")} Inspection Cycles ({visibleInspectionCycles.length})</h3>
            <div className="inspection-cycle-results-guidance">
                <p>Open an inspection cycle title to view its details and next steps.</p>
              {(activeTab === 3 || filters.status !== "all" || quickFilter !== "all") && (
                <button
                  type="button"
                  className="inspection-cycle-results-reset"
                  onClick={() => {
                    resetFilters();
                    if (activeTab === 3) {
                      setactiveTab(1);
                      loadActiveInspectionCycles();
                    }
                  }}
                >
                  Show all inspection cycles
                </button>
              )}
            </div>
          </div>
          <div className="inspection-cycle-results-help" role="note" aria-label="Grid action help">
            <i className="bx bx-info-circle" aria-hidden="true" />
            <p><strong>Preview</strong> opens the inspection cycle overview.<br />Use the <strong>three-dot menu (⋮)</strong> to preview, view activities{!isEngagementMember && " or edit cycle details"}.</p>
          </div>
        </div>
        <TabContent className="inspection-cycle-content" activeTab={showTab}>
          <TabPane tabId={1}>
            <Row>
              <Col xl={12}>
                <CustomDataGrid
                  showToolbar={false}
                  filterContent={
                    <div>
                      <label className="piers-grid-filters__search">
                        <span className="visually-hidden">Search inspection cycles</span>
                        <input
                          value={filters.title || ""}
                          onChange={(event) => updateFilter("title", event.target.value)}
                          placeholder="Search inspection cycles..."
                        />
                      </label>
                      <label>
                        Status
                        <select value={filters.status} onChange={(event) => updateFilter("status", event.target.value)}>
                          <option value="all">All Statuses</option>
                          <option value="not-started">Not Started</option>
                          <option value="in-progress">In Progress</option>
                          <option value="completed">Completed</option>
                        </select>
                      </label>
                      <label>
                        Standard Type
                        <select value={filters.standard} onChange={(event) => updateFilter("standard", event.target.value)}>
                          <option value="all">All Standard Types</option>
                          {standardOptions.map((standard) => <option key={standard} value={standard}>{standard}</option>)}
                        </select>
                      </label>
                      <button type="button" onClick={resetFilters}>Clear</button>
                    </div>
                  }
                  data={visibleInspectionCycles}
                  loading={gridLoading}
                  emptyState={{
                    title:
                      activeTab === 1
                        ? "Create your first Inspection Cycle"
                        : activeTab === 3 ? "No archived inspection cycles" : "No past inspection cycles",
                    description: isEngagementMember
                      ? "Inspection cycles available to your account appear here. Contact your firm administrator for access or assignments."
                      : "An Inspection Cycle defines the period, standard, owner and engagements to be reviewed.",
                    icon: "bx-calendar",
                    error: gridError,
                    onRetry: loadData,
                    filtered:
                      inspectionCycles.length > 0 ||
                      quickFilter !== "all" ||
                      Object.entries(filters).some(([key, value]) => key === "title" ? Boolean(value) : value !== "all"),
                    onReset: () => {
                      setFilters({
                        status: "all",
                        standard: "all",
                      });
                      setQuickFilter("all");
                    },
                    onAction:
                      !isEngagementMember && activeTab === 1
                        ? newInspectionCycle
                        : undefined,
                    actionLabel: "Create Inspection Cycle",
                    helpHref: "/piers/getting-started",
                  }}
                  columns={inspectionCycleColumns}
                  onRefresh={loadData}
                  fileName="inspection-cycles"
                  emptyMessage="No inspection cycles match your current filters."
                  initialPageSize={10}
                  rowHeight={56}
                  columnHeaderHeight={56}
                  gridSx={{
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#ffffff !important",
                      borderBottom: "1px solid #e4e8f0",
                    },
                    "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader--sortable":
                      {
                        backgroundColor: "#ffffff !important",
                        color: "#52627f",
                      },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      color: "#52627f",
                      fontSize: 12,
                      fontWeight: 700,
                      letterSpacing: ".2px",
                    },
                    "& .MuiDataGrid-columnSeparator": { color: "#e7ebf2" },
                    "& .MuiDataGrid-cell": {
                      borderBottomColor: "#edf0f5",
                      color: "#273957",
                      fontSize: 13,
                    },
                    "& .MuiDataGrid-row:hover": { backgroundColor: "#f8faff" },
                    "& .MuiDataGrid-footerContainer": {
                      borderTopColor: "#e7ebf2",
                      fontSize: 14,
                    },
                    "& .MuiDataGrid-footerContainer .MuiTypography-root, & .MuiDataGrid-toolbarContainer .MuiInputBase-input, & .MuiDataGrid-toolbarContainer .MuiButton-root":
                      {
                        fontSize: 14,
                      },
                  }}
                />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
        <Offcanvas
          backdrop="static"
          className="inspection-cycle-drawer"
          direction="end"
          isOpen={inspectionCycleOpen}
          toggle={toggleInspectionCycle}
        >
          <OffcanvasHeader
            toggle={toggleInspectionCycle}
            className="canvasHeader"
          >
            {detailId ? "Edit Inspection Cycle" : "New Inspection Cycle"}
          </OffcanvasHeader>
          <OffcanvasBody>
            <InspectionCycleDetailsForm
              dataId={detailId}
              closeAction={onInspectionCycleClose}
              onDirtyChange={setInspectionCycleFormDirty}
              onRequestClose={toggleInspectionCycle}
            />
          </OffcanvasBody>
        </Offcanvas>
        <UnsavedChangesDialog
          isOpen={inspectionCycleDiscardConfirmOpen}
          onContinue={() => setInspectionCycleDiscardConfirmOpen(false)}
          onDiscard={discardInspectionCycleDraft}
          subject="inspection cycle details"
        />

        <Offcanvas
          backdrop="static"
          className="inspection-activities-drawer"
          direction="end"
          isOpen={inspectionCycleDetailsOpen}
          toggle={toggleInspectionCycleDetails}
        >
          <OffcanvasHeader
            toggle={toggleInspectionCycleDetails}
            className="canvasHeader"
          >
            Inspection Cycle Activities
          </OffcanvasHeader>
          <OffcanvasBody>
            <InspectionCycleHistory dataId={detailId} />
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </React.Fragment>
  );
};

export default InspectionCycleList;
